import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { IUTPermitEmpty } from '@ruby/modules/unit-train/models/unit-train-permit.interface';
import { fromPermit, PermitActions, PermitSelectors } from '@ruby/modules/unit-train/store/permit.index';

@Component({
  selector: 'ng-empty-permit-container',
  templateUrl: './empty-permit.container.html',
  styleUrls: ['./empty-permit.container.scss']
})
export class EmptyPermitContainer implements OnInit, OnDestroy {
  @Input() permit!: { name: string; title?: string; permitType: string };
  store$!: Observable<{ permit: fromPermit.PermitState }>;
  permitDetail!: IUTPermitEmpty;

  constructor(private store: Store) {}

  ngOnInit(): void {
    this.store$ = this.store.select(PermitSelectors.selectPermit(this.permit.name)).pipe(
      tap((state: { permit: fromPermit.PermitState }) => this.permitDetail = state.permit.permit as unknown as IUTPermitEmpty)
    );
  }

  ngOnDestroy(): void {
    this.store.dispatch(PermitActions.removePermit({ data: this.permit.name }));
  }

  /**
   * Get Permit
   *
   * @summary Get Permit
   * @returns void
   */
  getPermit(): void {
    const permit = { permitName: this.permit.name, permitId: String(this.permitDetail.permitId), permitType: this.permit.permitType };
    this.store.dispatch(PermitActions.loadPermit({ data: permit }));
  }
}
